import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=63e8ef68&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=63e8ef68&scoped=true&lang=css&"
import style1 from "./Form.vue?vue&type=style&index=1&id=63e8ef68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8ef68",
  null
  
)

export default component.exports